import {Button} from '@wandb/weave/components';
import * as React from 'react';

import {useIssuesContext} from '../../../state/issues/IssuesContext';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';

export const RunIssuesButton = () => {
  const {activeIssues = [], activeErrorDrawer} = useIssuesContext();
  const {toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  return (
    <Button
      startIcon="warning"
      onClick={() => {
        toggleWorkspaceDrawer('run-issues');
      }}
      variant="secondary">
      {activeErrorDrawer ? 'Issues' : `Issues (${activeIssues.length})`}
    </Button>
  );
};
